import React, { useEffect, useState } from "react";
import { useSeo } from "@/lib/seo";

export default function Privacy() {
  useSeo({ title: "Privacy Policy", description: "How Paint With Tay collects and uses your information." });
  const [content, setContent] = useState({});
  useEffect(() => { import("@/lib/api").then(({ api }) => api.get("/content").then((r) => setContent(r.data || {}))); }, []);
  return (
    <div className="section py-14 max-w-3xl prose-custom" data-testid="privacy-page">
      <h1 className="font-heading text-4xl sm:text-5xl font-700 mb-2">Privacy Policy</h1>
      <p className="text-ink/60 mb-8">Last updated {new Date().getFullYear()}</p>
      <div className="space-y-5 text-ink/85 font-body text-lg">
        <p>Paint With Tay respects your privacy. This policy explains what information we collect and how we use it.</p>
        <h2 className="font-heading text-2xl font-600">What we collect</h2>
        <p>When you submit a booking request or contact form, we collect the details you provide — such as your name, email, phone number, event date, location, and event details — so we can respond and arrange your booking.</p>
        <h2 className="font-heading text-2xl font-600">How we use it</h2>
        <p>Your information is used only to communicate with you about your enquiry or booking, to schedule and deliver our services, and to keep our own records. We do not sell or rent your personal information.</p>
        <h2 className="font-heading text-2xl font-600">Storage & security</h2>
        <p>Booking and contact details are stored securely and kept only as long as needed for our records and legal obligations.</p>
        <h2 className="font-heading text-2xl font-600">Cookies</h2>
        <p>This website uses only the cookies necessary for it to function, including a secure sign-in cookie for the business owner’s admin area.</p>
        <h2 className="font-heading text-2xl font-600">Contact</h2>
        <p>Questions about your privacy? Email us at {content.contact_email || "paintwithtay@gmail.com"}.</p>
      </div>
    </div>
  );
}
